
import { User, Phone } from 'lucide-react';
// import { UserType } from '../../../globals';
import {formatPhone} from "../../../utils/formatters/formatPhoneNumber";
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';

/**
 * Персональные данные пользователя
 * @param user - данные пользователя
 * @returns 
 */
const UserInfo = () => {
  const user = useAppSelector((state: RootState) => state.user.userInfo);

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold">Личные данные</h2>
      </div>
      
      <div className="grid gap-6 md:grid-cols-2">
        <div className="flex items-start space-x-3">
          <User className="mt-1 h-5 w-5 text-autoparts-orange" />
          <div>
            <p className="text-sm text-gray-500">ФИО</p>
            <p className="font-medium">{user?.customerName}</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Phone className="mt-1 h-5 w-5 text-autoparts-orange" />
          <div>
            <p className="text-sm text-gray-500">Телефон</p>
            <p className="font-medium">{user && user.username ? formatPhone(user.username) : ''}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
